<template>
    <div class="container">          
      <!--UPLOAD-->      
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">        
        <div class="dropbox">
          <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
            <p v-if="isInitial">              
              Drag your file here to begin<br> or click to browse<br>
              Image less then {{config.maxsize}}Mb
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p>
        </div>
      </form>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

const STATUS_INITIAL = 0,STATUS_SAVING = 1,STATUS_SUCCESS = 2,STATUS_FAILED = 3;

export default {  
  props: ["config"],
  data: function() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,        
      uploadFieldName: 'photo'
    };
  },
  methods: {
    ...mapActions(["addImageToEntityReduceSize","setToastMessage"]),
    reset() {
      // reset form to initial state      
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      let myReader = new FileReader();
      let file = window.event.target.files[0];      
      if(file.size > this.config.maxsize * 1000000)
      {
          this.setToastMessage({ type: 'error', message: `Image size is to large, reduce the image size to less then ${this.config.maxsize}MB or use an existing edited image rather then your camera.`, title: 'Warning' })          
          this.reset()          
          return false
      }
      
      this.addImageToEntityReduceSize({id:this.config.id,business_id:this.config.business_id,location:this.config.location,linkedbusinesslocation:this.config.linkedbusinesslocation,push:this.config.push || false, file:file}).then(
          () => {
            this.reset() 
          },
          (error) => {            
            this.currentStatus = STATUS_FAILED;
          }
      );     
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.save(formData);
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  created() {},
  mounted() {
    this.reset();
  }
};
</script>
 
  <style>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  /* padding: 10px 10px; */
  min-height: 100px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ImageEditor.vue